function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// import Loading from 'researcher/components/Loading';
import { getWeChatBindingQrCode } from 'shared/account/actions';
var WeChatBindingQR = function WeChatBindingQR() {
  var dispatch = useDispatch();
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    qrCodeUrl = _useState2[0],
    setQrCodeUrl = _useState2[1];
  var qrCodeUrlRetrieved = useSelector(function (_ref) {
    var account = _ref.account;
    return !account.status.updating;
  });
  useEffect(function () {
    dispatch(getWeChatBindingQrCode()).then(function (_ref2) {
      var qrCodeUrl = _ref2.qrCodeUrl;
      return setQrCodeUrl(qrCodeUrl);
    });
  }, []);
  if (!qrCodeUrl && !qrCodeUrlRetrieved) {
    return 'Load....';
  }
  if (!qrCodeUrl && qrCodeUrlRetrieved) {
    return /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      className: "display-2",
      icon: "fa-solid fa-circle-exclamation"
    });
  }
  return /*#__PURE__*/React.createElement("img", {
    src: qrCodeUrl,
    alt: "qr code",
    width: "150px",
    height: "150px"
  });
};
export default WeChatBindingQR;